module.exports = __webpack_public_path__ + "img/full7-min.5684f7be.png";